var render, staticRenderFns
import script from "./zgy-button.vue?vue&type=script&lang=js&"
export * from "./zgy-button.vue?vue&type=script&lang=js&"
import style0 from "./zgy-button.vue?vue&type=style&index=0&id=52ed342b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed342b",
  null
  
)

export default component.exports